import { DEFAULT_LOCALE } from '~/core/constants/env'

import ENUMS_DATA from '../../.talentsforce/data/enums.json'
import ENUMS_DATA_JA from '../../.talentsforce/data/enums_ja.json'

type IEnumType =
  | 'All'
  | ''
  | 'ProfileSourced'
  | 'JobRemoteStatus'
  | 'JobCurrency'
  | 'JobEducation'
  | 'JobEmployment'
  | 'JobJobLevel'
  | 'JobStatus'
  | 'JobTypeOfSalary'
  | 'CompanySize'
  | 'InterviewFeedbackEvaluation'
  | 'InterviewEvent'
  | 'EmailKind'
  | 'StageGroup'
  | 'CompanyLanguage'
  | 'Provider'
  | 'FromProduct'
  | 'UserLanguage'
  | 'Status'
  | 'ApplicantStatus'
  | 'ApplicantIncoming'
  | 'InterviewState'
  | 'IkitOverallFeedback'
  | 'JobIkitStatus'
  | 'TalentPoolStatus'
  | 'TaskStatus'
  | 'RejectedReasonKind'
  | 'USettingKind'
  | 'USettingGroup'
  | 'RequisitionStatus'
  | 'RequisitionReason'
  | 'RequisitionCurrency'
  | 'RequisitionTypeOfSalary'
  | 'RequisitionStepStatus'
  | 'JobRecruiterResponsibility'
  | 'CustomFieldObjectKind'
  | 'CustomFieldKind'
  | 'ProfileProfileLevel'
  | 'CompanyCurrency'
  | 'ContactStatus'
  | 'ProfileTypeOfExpectedSalary'
  | 'ProfileTypeOfCurrentSalary'
  | 'CourseProvider'
  | 'CourseLevel'
  | 'CourseLanguage'
  | 'Course'
  | 'CoursePrice'
  | 'EmployerPlacementStatus'
  | 'EmployerPlacementCurrencyOfRevenue'
  | 'EmployerPlacementTypeOfFee'
  | 'EmployerPlacementTypeOfSalary'
  | 'EmployerCompanySize'
  | 'SkillsIncoming'
  | 'IkitTemplateUsage'
  | 'EmployerCompanyKind'
  | 'ConsentPolicyStatus'
  | 'SendMailSettingToUserGroups'

type EnumValue = {
  name?: string
  description?: string
}

type EnumDataItem = {
  data?: {
    __type?: {
      name?: IEnumType | string
      enumValues?: EnumValue[]
    }
  }
}

const useEnumsData = ({
  enumType = 'All',
  locale = DEFAULT_LOCALE
}: {
  enumType: IEnumType
  locale?: string
}) => {
  const list = (locale === DEFAULT_LOCALE ? ENUMS_DATA : ENUMS_DATA_JA || []) as EnumDataItem[]
  const filter = list.filter((item) => item?.data?.__type?.name === enumType)?.[0]

  return (filter?.data?.__type?.enumValues || []).map((item) => ({
    value: String(item.name),
    supportingObj: {
      name: item.description || ''
    }
  })) as any
}

export default useEnumsData
